module.exports = __webpack_public_path__ + "img/languages.2011bdaa.svg";